const sort = function(a, b)
{
	a = a.split('.')
	b = b.split('.')

	for ( let i=0; i<a.length; i++ )
	{
		a[i] = parseInt(a[i])
		b[i] = parseInt(b[i])

		if ( a[i] < b[i] )
		{
			return -1
		}
		else if ( a[i] > b[i] )
		{
			return 1
		}

		return 0
	}
}

export default sort